import './App.css';
import { Link } from "react-scroll"
import profile from "./images/profile.jpg"
import java from "./images/javaicon.png"
import python from "./images/pythonicon.ico"
import javascript from "./images/javascripticon.png"
import machinelearning from "./images/machinelearningicon.png"
import leadership from "./images/leadershipicon.webp"
import reactIcon from "./images/reacticon.svg"
import emailjs from 'emailjs-com'
import React, { useRef } from 'react'
import recycle from "/Users/shreyajha/Downloads/Independent Projects/Portfolio/react-portfolio/src/images/recyclewebpage.png"
import neural from "./images/neuralnetworkpotential.gif"
import datastructure from "./images/datastructure.png"

function App() {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        'service_ehpzdf2',
        'template_7qmc23q',
        form.current,
        '2o-hjO7-lo03YB-QG'
      )
      .then(
        (result) => {
          alert('message sent successfully...');
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
      e.target.reset();
  };

  return (
    <div className="App">
    <header className="nav">
      <nav className="nav__container__actions">
        <ul>
          <li>
            <Link activeClass="active" smooth spy to="about">
              ABOUT
            </Link>
          </li>
          <li>
            <Link activeClass="active" smooth spy to="skills">
              SKILLS
            </Link>
          </li>
          <li>
            <Link activeClass="active" smooth spy to="projects">
              PROJECTS
            </Link>
          </li>
          <li>
            <Link activeClass="active" smooth spy to="contact">
              CONTACT ME
            </Link>
          </li>
        </ul>
      </nav>
    </header>
    <section id="about">
      <div className ="namePicture">
        <h1> SHREYA JHA </h1>
        <img src={profile} alt="Avatar"/>
        <h2> Math and Computer Science student @ Georgia Tech - Machine Learning Undergraduate Researcher</h2>
      </div>
    </section>
    <section id="skills"> 
      <div className="skillsHeading">
        <h1> SKILLS </h1>
        <p> Listed below are some of my skills. I'm always looking for the opportunity to gain more!</p>
      </div>
      <div className="skillcards">
        <div className="skillcard"> 
          <img src={java}/>
          <h1> Java </h1>
          <p> I have over 3 years of experience in Java, in which I've implemented various data
            structure (LinkedLists, AVLs, Pattern matching algorithms) and created java fx based applications
            with functional user interfaces. 
          </p>
        </div>
        <div className="skillcard"> 
          <img src={python}/> 
          <h1> Python </h1>
          <p> I have 2 years of experience in Python, with my skills accumulated through my research 
            and through classwork. One project I created using Python is  a computational model of electric and magnetic
            fields and forces, which calculates forces of dipoles on point charges and visually models
            field vectors.
          </p>
        </div>
        <div className="skillcard">  
          <img src={javascript}/> 
          <h1> Javascript, HTML, CSS </h1>
          <p> I have over 4 years of experience programming in Javascript, HTML, CSS. 
            I have created various applications in Javascript, including a greeting card generator with
            a functional user interface. 
          </p>
        </div>
        <div className="skillcard"> 
          <img src={machinelearning}/> 
          <h1> Machine Learning </h1>
          <p> As a member of the Medford Research Group at Georgia Tech, I conduct research
            in the machine learning subgroup, where I train neural networks to calculate potential
            energies of atomic reactions. Furthermore, starting January of 2023, I will be conducting
            research under Dr. Florian Schaefer, about competitive optimization, used by maching learning 
            algorithms. </p>
        </div>
        <div className="skillcard">
          <img src={reactIcon}/> 
          <h1> React.js </h1>
          <p> Through various independent projects, I've garnered experience using 
            the javascript framework React.js. Along with this portfolio, I've also created
            an education website using the framework about recycling at Georgia Tech.
          </p>
        </div>
        <div className="skillcard"> 
          <img src={leadership}/> 
          <h1> Leadership </h1>
          <p> Aside from my abilities as a developer and researcher, I am also the 
            dedicated president of an educational outreach organization, called Junior STEM. We as an organization
            volunteer at a local elementary school by performing science experiments, and we host a larger science exposition
            event with other Georgia Tech organizations every spring!
          </p>
        </div>
      </div>
      </section>
    <section id="projects">
      <div className="projectHeading">
        <h1>PROJECTS</h1>
        <p>Here are some of my Academic and Independent Projects!</p>
      </div>
      <div className="projectcards">
        <div className="projectcard"> 
          <h1 className="linky">  <a style={{textDecoration: 'none'}} href="https://github.gatech.edu/hackgt9/sas" target="_blank"> Unleash the Green and Stay Grounded </a></h1>
          <img src={recycle}/>
          <p> A simple educational website about Recycling 
            at Georgia Tech, created through React</p>
        </div>
        <div className="projectcard"> 
          <h1 className="linky"><a style={{textDecoration: 'none'}} href="https://github.com/sjha75/Training-Neural-Network" target="_blank"> Energies and Forces on Water Molecule </a></h1>
          <img src={neural}/>
          <p> A program that trains a neural-network model to predict energies and forces 
            of 0.05 eV/Angstrom on water, using PyTorch.
          </p>

        </div>
        <div className="projectcard2"> 
          <h1> Data Structures and Algorithms in Java</h1>
          <img src={datastructure}/>
          <p> Implementations of data structures, such as Linked Lists and AVls, and 
            algorithms, such as dijkstra's shortest path, in Java. Email me if you want to 
            see the programs!
          </p>
        </div>
      </div>
    </section>
    <section id="contact">
    <div className="contactHeading">
      <h1>CONTACT ME</h1>
      <h3>Email: sjha75@gatech.edu || shreya.jha654321@gmail.com</h3>
      <h3>Phone: 508-320-7739</h3>
      <p> You could also use the form below!</p>

    </div>
    <div className = "classForm">
      <h1>Contact Form</h1>
      <form className='cf' ref={form} onSubmit={sendEmail}>
        <div className='half left cf'>
          <input type='text' placeholder='Name' name='user_name' />
          <input type='email' placeholder='Email address' name='user_email' />
        </div>
        <div className='half right cf'>
          <textarea name='message' type='text' placeholder='Message'></textarea>
        </div>
        <input type='submit' value='Submit' id='input-submit' />
      </form>
    </div>
    </section>
  </div>
  );
}

export default App;
